import { Risk as RiskProtos } from '@qover-private/protos-web/qover/dojo/bike/v1/risk';
import { formatToServer, toDate } from '@qover/utils/src/date';
import { Risk } from '../Risk';

export function mapToApiRequest(risk: Risk): RiskProtos {
  const bikePurchaseDate = toDate(risk?.bikePurchaseDate ?? new Date());

  return {
    ...risk,
    bikePurchaseDate: formatToServer(bikePurchaseDate),
  };
}
